import cx from "classnames";
import React from "react";

import styles from "../ProfilePage.module.scss";

export type DeveloperApiTab = "keys" | "usage" | "billing";

interface ApiTabBarProps {
  activeTab: DeveloperApiTab;
  onChange: (tab: DeveloperApiTab) => void;
}

const ApiTabBar: React.FC<ApiTabBarProps> = ({ activeTab, onChange }) => (
  <div className={styles.apiTabBar}>
    <button
      type="button"
      className={cx(
        styles.apiTabBtn,
        activeTab === "keys" && styles.apiTabBtnActive,
      )}
      onClick={() => onChange("keys")}
    >
      API Keys
    </button>
    <button
      type="button"
      className={cx(
        styles.apiTabBtn,
        activeTab === "usage" && styles.apiTabBtnActive,
      )}
      onClick={() => onChange("usage")}
    >
      Usage
    </button>
    <button
      type="button"
      className={cx(
        styles.apiTabBtn,
        activeTab === "billing" && styles.apiTabBtnActive,
      )}
      onClick={() => onChange("billing")}
    >
      Billing
    </button>
  </div>
);

export default ApiTabBar;
